// extracted by mini-css-extract-plugin
module.exports = {"container":"TimeoutPage_container__2Z1ZV","title":"TimeoutPage_title__1Bxwa","subtitle":"TimeoutPage_subtitle__ci_e1","description":"TimeoutPage_description__hXfxd"};